import { c as _c } from "react/compiler-runtime";
import React from "react";
interface WaveWinnersSmallEmptyProps {
  readonly isMultiDecision?: boolean | undefined;
}
export const WaveWinnersSmallEmpty: React.FC<WaveWinnersSmallEmptyProps> = t0 => {
  const $ = _c(3);
  const {
    isMultiDecision: t1
  } = t0;
  const isMultiDecision = t1 === undefined ? false : t1;
  const message = isMultiDecision ? "No winners have been announced for this wave yet. Check back later!" : "This wave ended without any winning submissions";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-mt-4 tw-text-base tw-font-semibold tw-text-iron-300">{"No Winners Yet"}</div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== message) {
    t3 = <div className="tw-p-3"><div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8">{t2}<p className="tw-mb-0 tw-mt-2 tw-text-sm tw-text-iron-400 tw-text-center">{message}</p></div></div>;
    $[1] = message;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};